<template>
  <form-row>
    <label class="ordered-counter">
      {{ $t('product-detail.form.route.label') }}
    </label>

    {{ $t('product-detail.form.route.from') }}:
    <auto-complete :options="fromStopsToShow"
                   :value="fromStop ? fromStop.id : ''"
                   :placeholder="$t('product-detail.form.route.from')"
                   @input="value => $emit('inputFromStopId', stops.find(stop => stop.id === value))"/>

    <ul v-if="validationFromStop.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
      <li v-if="!validationFromStop.required">{{ $t('product-detail.form.route.validation.required') }}</li>
    </ul>

    <br>
    {{ $t('product-detail.form.route.to') }}:
    <auto-complete :options="toStopsToShow"
                   :value="toStop ? toStop.id : ''"
                   :placeholder="$t('product-detail.form.route.to')"
                   @input="value => $emit('inputToStopId', stops.find(stop => stop.id === value))"/>

    <ul v-if="validationToStop.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
      <li v-if="!validationToStop.required">{{ $t('product-detail.form.route.validation.required') }}</li>
    </ul>
  </form-row>
</template>

<script>
import FormRow from '../components/FormRow'
import AutoComplete from '../components/AutoComplete'
import { Stop } from '../../types/filter-entity/stop'

function compareStrings (stringA, stringB) {
  stringA = stringA.toUpperCase()
  stringB = stringB.toUpperCase()

  return (stringA < stringB) ? -1 : (stringA > stringB) ? 1 : 0
}

export default {
  components: {
    AutoComplete,
    FormRow
  },
  props: {
    toStop: {
      type: Stop,
      default: null
    },
    fromStop: {
      type: Stop,
      default: null
    },
    stops: {
      type: Array,
      required: true
    },
    validationToStop: {
      type: Object,
      default: () => ({})
    },
    validationFromStop: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    fromStopsToShow: function () {
      return this.stops.filter(stop => stop.nrOfProductConfigurationsAsFromStop > 0)
        .sort((a, b) => compareStrings(a.title, b.title))
        .map(stop => ({ value: stop.title, data: stop.id }))
    },
    toStopsToShow: function () {
      return this.stops.filter(stop => stop.nrOfProductConfigurationsAsToStop > 0)
        .sort((a, b) => compareStrings(a.title, b.title))
        .map(stop => ({ value: stop.title, data: stop.id }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/order-item/Route.vue